import React, { useState, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Image = ({ className, src, alt, height, width }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    return (
        <LazyLoadImage
            role="img" 
            aria-label={alt} 
            alt={alt}
            height={height}
            src={src}
            width={width}
            className={className}
            wrapperClassName={className}
            style={isMobile ? { display: 'block', height: 'auto', width: 'auto' } : {}}
            loading="eager"
            threshold={0}
        />
    );
};

export default Image;
